import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { ThemeContext } from 'styled-components'

//https://css-tricks.com/accessible-svgs/#example-1-standalone-icon-meaningful

const Favorite = ({ fill = 'pink', border = 'none', altText = '' }) => {
  const themeContext = useContext(ThemeContext)
  const FILLS = {
    pink: themeContext.colors.pink51,
    none: 'none',
  }

  const BORDERS = {
    white: '#fff',
    black: '#000',
    none: 'none',
  }

  return (
    <svg
      width="100%"
      viewBox="0 0 24 24"
      fill={FILLS[fill]}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden={altText === '' ? 'true' : 'false'}
      aria-labelledby="faveTitle"
    >
      <title className="faveTitle">{altText}</title>
      <path
        d="M4.49955 13.5L10.5853 19.5858C11.3664 20.3669 12.6327 20.3669 13.4138 19.5858L19.4995 13.5C21.4325 11.567 21.4325 8.43304 19.4995 6.50004C17.5666 4.56704 14.4325 4.56704 12.4996 6.50004C12.2234 6.77618 11.7757 6.77618 11.4996 6.50004C9.56655 4.56704 6.43255 4.56704 4.49955 6.50004C2.56655 8.43304 2.56656 11.567 4.49955 13.5Z"
        fill="#E61C54"
        stroke={BORDERS[border]}
      />
    </svg>
  )
}

Favorite.propTypes = {
  fill: PropTypes.oneOf(['none', 'pink']),
  border: PropTypes.oneOf(['black', 'white']),
  altText: PropTypes.string,
}

export default Favorite
